export const TYPECIRCLARS = `/v2/guest/regulations?model=decree`;
export const CIRCLARS = (id) => `/v2/guest/regulations/${id}?model=decree`;
